export default __webpack_public_path__ + "static/media/icon_dollar.8908c0f2.svg";